"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TabsPanel = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _styleUtilities = require("@creditas-lab/style-utilities");

var _hooks = require("../../hooks");

var _utils = require("../../utils");

var _tabsPanel = require("./tabsPanel.style");

var _core = require("@emotion/core");

const propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.node.isRequired
} : {};
const MOBILE_MEDIA_QUERY = `(max-width: ${_styleUtilities.sizes.md}px)`;

const TabsPanel = ({
  children
}) => {
  const tabProps = (0, _hooks.useTabs)();
  const {
    activeIndex,
    handleChange
  } = tabProps;
  const {
    matches: isMobile
  } = window.matchMedia(MOBILE_MEDIA_QUERY);
  return (0, _core.jsx)(_tabsPanel.SwipeableViews, {
    index: activeIndex,
    onChangeIndex: handleChange,
    animateTransitions: isMobile
  }, _react.default.Children.map(children, (0, _utils.injectProps)(tabProps)));
};

exports.TabsPanel = TabsPanel;
process.env.NODE_ENV !== "production" ? TabsPanel.propTypes = propTypes : void 0;
TabsPanel.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "TabsPanel",
  "props": {
    "children": {
      "type": {
        "name": "node"
      },
      "required": true,
      "description": ""
    }
  }
};